import {useLands} from '#/hooks/query/use-lands';
import {LandAndTransaction} from '#/repository/types';
import {DisplayableShareLandTransaction, Land} from 'shareland-common';

const getSingleTransactionLandAndInfo = (
  transaction: DisplayableShareLandTransaction,
  lands: Land[],
): LandAndTransaction | undefined => {
  const land = lands.find(elem => elem.id === transaction.landId);

  if (!land) {
    return;
  }

  return {land, transaction};
};

export const useTransactionLandAndInfos = (
  singleTransactionOrArray: DisplayableShareLandTransaction | DisplayableShareLandTransaction[] | undefined,
): LandAndTransaction[] | undefined => {
  const {data: lands = []} = useLands();

  if (singleTransactionOrArray === undefined || lands === undefined) {
    return;
  }

  const targetAsArray = Array.isArray(singleTransactionOrArray) ? singleTransactionOrArray : [singleTransactionOrArray];
  return targetAsArray?.reduce((acc: Array<LandAndTransaction>, transaction) => {
    const transactionLandAndInfo = getSingleTransactionLandAndInfo(transaction, lands);

    if (transactionLandAndInfo) {
      acc.push(transactionLandAndInfo);
    }
    return acc;
  }, []);
};
